import { render } from "./list-inventory.vue?vue&type=template&id=39e63601&scoped=true"
import script from "./list-inventory.vue?vue&type=script&lang=js"
export * from "./list-inventory.vue?vue&type=script&lang=js"

import "./list-inventory.vue?vue&type=style&index=0&id=39e63601&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e63601"]])

export default __exports__